var windowWidth = $(window).width();

// JSON.pruned : a function to stringify any object without overflow
// example : var json = JSON.pruned({a:'e', c:[1,2,{d:{e:42, f:'deep'}}]})
// two additional optional parameters :
//   - the maximal depth (default : 6)
//   - the maximal length of arrays (default : 50)
// GitHub : https://github.com/Canop/JSON.prune
// This is based on Douglas Crockford's code ( https://github.com/douglascrockford/JSON-js/blob/master/json2.js )
(function () {
    'use strict';

    var menu = $('.navbar-fixed-top');
    var body = $(document.body);

    if ( $(menu).length && body.length ) {
        $(body).css('padding-top', $(menu).height() + 'px');
    }

    var DEFAULT_MAX_DEPTH = 5;
    var DEFAULT_ARRAY_MAX_LENGTH = 500;
    var seen; // Same variable used for all stringifications

    Date.prototype.toPrunedJSON = Date.prototype.toJSON;
    String.prototype.toPrunedJSON = String.prototype.toJSON;

    var cx = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
        escapable = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
        meta = {    // table of character substitutions
            '\b': '\\b',
            '\t': '\\t',
            '\n': '\\n',
            '\f': '\\f',
            '\r': '\\r',
            '"' : '\\"',
            '\\': '\\\\'
        };

    function quote(string) {
        escapable.lastIndex = 0;
        return escapable.test(string) ? '"' + string.replace(escapable, function (a) {
            var c = meta[a];
            return typeof c === 'string'
                ? c
                : '\\u' + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
        }) + '"' : '"' + string + '"';
    }

    function str(key, holder, depthDecr, arrayMaxLength) {
        var i,          // The loop counter.
            k,          // The member key.
            v,          // The member value.
            length,
            partial,
            value = holder[key];
        if (value && typeof value === 'object' && typeof value.toPrunedJSON === 'function') {
            value = value.toPrunedJSON(key);
        }

        switch (typeof value) {
            case 'string':
                return quote(value);
            case 'number':
                return isFinite(value) ? String(value) : 'null';
            case 'boolean':
            case 'null':
                return String(value);
            case 'object':
                if (!value) {
                    return 'null';
                }
                if (depthDecr<=0 || seen.indexOf(value)!==-1) {
                    return '"-pruned-"';
                }
                seen.push(value);
                partial = [];
                if (Object.prototype.toString.apply(value) === '[object Array]') {
                    length = Math.min(value.length, arrayMaxLength);
                    for (i = 0; i < length; i += 1) {
                        partial[i] = str(i, value, depthDecr-1, arrayMaxLength) || 'null';
                    }
                    v = partial.length === 0
                        ? '[]'
                        : '[' + partial.join(',') + ']';
                    return v;
                }
                for (k in value) {
                    if (Object.prototype.hasOwnProperty.call(value, k)) {
                        try {
                            v = str(k, value, depthDecr-1, arrayMaxLength);
                            if (v) partial.push(quote(k) + ':' + v);
                        } catch (e) {
                            // this try/catch due to some "Accessing selectionEnd on an input element that cannot have a selection." on Chrome
                        }
                    }
                }
                v = partial.length === 0
                    ? '{}'
                    : '{' + partial.join(',') + '}';
                return v;
        }
    }

    JSON.pruned = function (value, depthDecr, arrayMaxLength) {
        seen = [];
        depthDecr = depthDecr || DEFAULT_MAX_DEPTH;
        arrayMaxLength = arrayMaxLength || DEFAULT_ARRAY_MAX_LENGTH;
        return str('', {'': value}, depthDecr, arrayMaxLength);
    };

}());

/**
 * Hide user tip
 *
 * @param link
 */
function hideTip(link)
{
    $.get(link);
}



/**
 * Functions related to tags
 */
function tags() {

    /**
     * Show how many tags has been selected by a user
     */
    function jsCountTags() {
        /**
         * @param (jQuery) $jsCountTagElement
         */
        function renderContent($jsCountTagElement) {
            var countSelectedTags = $jsCountTagElement.find('input:checked').length;
            var $tagHeadline = $jsCountTagElement.find('h4#tagHeadline'); //title

            if($tagHeadline.length < 1) {
                return;
            }

            var tagHeadlineContent = $tagHeadline.attr('data-text').replace('%count%', countSelectedTags);
            //set content
            $tagHeadline.html(tagHeadlineContent);

            //set all checked checkbox active css class
            $jsCountTagElement.find('input:checked').each(function() {
                $(this).closest('.btn-tag').addClass('active');
            });

        }

        //init all count tag headline contents
        $('.js-tags').each(function() {
            var $jsCountTagElement = $(this);

            renderContent($jsCountTagElement);
        })

        /**
         * Update count tag headline content on checkbox change
         */
        $('.js-tags input').on('change', function() {
            var $this = $(this);
            var $parent = $this.closest('.js-tags');

            renderContent($parent);
        })
    }

    //call
    jsCountTags();


    /**
     * Show accordions
     */
    function showAccordions() {
        if ($("#tagHeadline").length && $("#tagList").length) {
            $("#accordion").show();
        }

        if ($("#tagHeadline2").length && $("#tagList2").length) {
            $("#accordion2").show();
        }
    }

    //call
    showAccordions();
}

function snippets(data) {
    for (var key in data.snippets) {
        var $snippet = $('#' + key);

        if($snippet.attr('data-ajax-append')) {
            $('#' + key).append(data.snippets[key]);
        } else {
            $('#' + key).html(data.snippets[key]);
        }
    }
}

function textAreaAdjust(o) { // natahovací textarea v messengeru
    o.style.height = "1px";
    o.style.height = (25+o.scrollHeight)+"px";
}

// přizpůsobení výšek boxů podle nejvyššího

function adjustBox() {
    if (windowWidth > 767){
        var max = 0;
        $('#box-adjust .adjust-element').each(function(){
            $(this).css('min-height','0');
            if ($(this).outerHeight() > max) {
                max = $(this).outerHeight();
            }
        });
        $('#box-adjust .adjust-element').each(function(){
            $(this).css('min-height',max);
        });
        $('#box-adjust .adjust-element').each(function(){
            if ($(this).outerHeight() > max) {
                max = $(this).outerHeight();
            }
        });
        $('#box-adjust .adjust-element').each(function(){
            $(this).css('min-height',max);
        });
    }
}

function adjustBox2() {
    if (windowWidth > 767){
        var max = 0;
        $('#box-adjust .adjust-element2').each(function(){
            $(this).css('min-height','0');
            if ($(this).outerHeight() > max) {
                max = $(this).outerHeight();
            }
        });
        $('#box-adjust .adjust-element2').each(function(){
            $(this).css('min-height',max);
        });
    }
}

$('#confirm-delete').on('show.bs.modal', function(e) {
    $(this).find('.btn-ok').attr('href', $(e.relatedTarget).data('href'));
});

function adjustImage() {
    var max = 0;
    var height = 0;
    $('.image-16-9').each(function(){
        $(this).css('min-height','0');
        $(this).css('max-height','none');
        height = Math.round(($(this).width() / 16) * 9);
        if (height > max) {
            max = height;
        }
    });
    $('.image-16-9').each(function(){
        $(this).css('height',max);
    });
}

function adjustImage2() {
    var max = 0;
    var height = 0;
    $('.image-16-9_2').each(function(){
        $(this).css('min-height','0');
        $(this).css('max-height','none');
        height = Math.round(($(this).width() / 16) * 9);
        if (height > max) {
            max = height;
        }
    });
    $('.image-16-9_2').each(function(){
        $(this).css('height',max);
    });
}

/**
 * Set modal button link
 */
function setModalBtnLink() {
    $('.js-modal-link').on('click', function(e) {
        var modalLink = $(this).data('href');
        var target = $(this).data('target');
        var $target = $(target);

        $target.find('.js-btn-confirm').attr('href', modalLink);
    });
}

function fastSelectValue(selector, value) {
    var el = $(selector);
    var fstToggleBtn = el.parents('.fstElement').find('.fstToggleBtn');
    var fstResults = el.parents('.fstElement').find('.fstResults');
    el.find('option').removeAttr('selected');
    var text = el.find('option[value="' + value + '"]').attr('selected', 'selected').text();
    fstResults.find('.fstResultItem').removeClass('fstSelected');
    fstResults.find('.fstResultItem:contains(' + text + ')').addClass('fstSelected');
    fstToggleBtn.text(text);
    el.val(value);
}

$(window).resize(function() {
    windowWidth = $(window).width();
    setTimeout(function () {
        /*
        adjustBox();
        adjustBox2();
        adjustImage();
        adjustImage2();
        */
    }, 100);
});

$( document ).ajaxComplete(function() {
    setTimeout(function () {
        /*
        adjustBox();
        adjustBox2();
        adjustImage();
        adjustImage2();
        */
        $('.adjust-element-grid').responsiveEqualHeightGrid();
        $('.adjust-element-grid-2').responsiveEqualHeightGrid();
        $(".scroll-box").niceScroll({
            cursorborder: "none",
            background:"transparent",
            cursorcolor: "transparent",
            horizrailenabled: false
        });
    }, 1);
})
    .on('click', '.fstResultItem.fstSelected', function () {
        var text = $(this).text();
        $(this).parents('.fstElement').find('.fstToggleBtn').text(text);
    })
    .on('click', '.panel-shadow-hover[data-href]', function (e) {
        var target = $(e.target);
        if (!target.is('a') && !target.is('button') && !target.parent().is('a') && !target.parent().is('button')) {
            var url = $(this).attr('data-href');
            window.location.replace(url);
        }
    });

$(document).ready(function(){

    windowWidth = $(window).width();

    $('.dropdown').on('show.bs.dropdown', function(e){
        $(this).find('.dropdown-menu').first().stop(true, true).slideDown(300);
    });
    $('.dropdown').on('hide.bs.dropdown', function(e){
        $(this).find('.dropdown-menu').first().stop(true, true).slideUp(300);
    });
    $('.tagsInput').fastselect();
    $('.progress .progress-bar').css("width",
        function() {
            return $(this).attr("aria-valuenow") + "%";
        }
    );

    setModalBtnLink();

    $('#collapseOne').on('hide.bs.collapse', function () {
        $('#icon-switch-one').removeClass('icon-arrowup');
        $('#icon-switch-one').addClass('icon-arrowdown');
    });
    $('#collapseOne').on('show.bs.collapse', function () {
        $('#icon-switch-one').removeClass('icon-arrowdown');
        $('#icon-switch-one').addClass('icon-arrowup');
    });

    $('#snippet--tagList').on('click', function() {
        if($('#collapseOne').hasClass('in')) {
            setTimeout(function() {
                $('#icon-switch-one').removeClass('icon-arrowup');
                $('#icon-switch-one').addClass('icon-arrowdown');
            }, 500);
        } else {
            setTimeout(function() {
                $('#icon-switch-one').removeClass('icon-arrowdown');
                $('#icon-switch-one').addClass('icon-arrowup');
            }, 500);
        }
    });
    $('.increase-input #plus').on('click', function(){
        var value = parseInt($(this).parent().parent().find('.form-control').val());
        value = value + 1;
        $(this).parent().parent().find('.form-control').val(value);
    });
    $('.increase-input #minus').on('click', function(){
        var value = parseInt($(this).parent().parent().find('.form-control').val());
        if (value > 1) {
            value = value - 1;
            $(this).parent().parent().find('.form-control').val(value);
        }
    });
    $('.answer').on('click',function(){
        $(this).parent().parent().find('.textarea-toggle').show(300);
    });
    $('.loading-show').on('click',function(){
        $('.modal-loading').show();
        $('.modal-loading').animate({opacity:1},300);
    });
    $('.show-more-text').on('click', function() {
        if ($(this).parent().find('.hidden-actions').is(':hidden')) {
            $(this).parent().find('.hidden-actions').slideDown(500);
            $(this).find('span').addClass('opened');
        } else {
            $(this).parent().find('.hidden-actions').slideUp(500);
            $(this).find('span').removeClass('opened');
        }
    });

    $('#format-select button').on('click', function() {
        var id = '#' + $(this).attr("data-action");
        $('#switch-actions .hidden-switch').each(function(){
            $(this).hide();
        });
        $('#switch-actions').find(id).show();
    });

    //Postranní menu v nastavení
    $('.settings-menu li').first().addClass('active');
    $('#window-switch, .window-switch').children().hide();
    $('#window-switch .window, .window-switch .window').first().show();
    $('.settings-menu li').on('click', function(){
        var id = '#' + $(this).attr("data-action");
        $('#window-switch, .window-switch').children().hide();
        $('#window-switch, .window-switch').find(id).show();
        $('.settings-menu li').each(function(){
            $(this).removeClass('active');
        });
        $(this).addClass('active');
    });

    $('.settings-menu li').first().addClass('active');

    /*
    adjustBox();
    adjustBox2();
     */
    //přizpůsobení obrázků 16:9
    /*
    adjustImage();
    adjustImage2();
    */
    tags();

    $('form').submit(function () {
        if ($(this).hasClass('load')) {
            $('.modal-loading').show();
            $('.modal-loading').animate({opacity:1},300);
        }
    });

    $('.adjust-element-grid').responsiveEqualHeightGrid();
    $('.adjust-element-grid-2').responsiveEqualHeightGrid();

    var path = window.location.pathname;

    if (!/^\/academy\//.test(path) && path != '/academy/') {
        delete localStorage.academyList;
    }
    if (!/^\/user\/exercise\//.test(path) && path != '/user/exercise/' &&
        !/^\/trainer\/library\//.test(path) && path != '/trainer/library/') {
        delete localStorage.userExerciseList;
    }
    if (!/^\/user\/training\//.test(path) && path != '/user/training/') {
        delete localStorage.userTrainingList;
    }
    if (!/^\/trainer\/training\//.test(path) && path != '/trainer/training/') {
        delete localStorage.trainerTrainingList;
    }
    if (!/^\/user\/my-academy\//.test(path) && path != '/user/my-academy/') {
        delete localStorage.userMyAcademyList;
    }

    setTimeout(function() {
        $('.flash-messages .alert').each(function (index, item) {
            var $item = $(item);
            var msg = $item.get(0);
            var hasAlertLongClass = Array.from(msg.classList).some(className => className.includes('alert-long'));

            if(!hasAlertLongClass) {
                $item.fadeOut('fast');
            }
        });
    }, 3000);

    $('#searchInput').keyup(function(e) {
        if (e.which == 13) // Enter key
            $('#searchButton').click();
    });

    $('.trigger-forgotten-pass-modal').on('click', function () {
        var menu = document.getElementById('menu-container');
        var userMenu = document.getElementById('user-menu-toggle');
        if (userMenu) {
            userMenu.checked = false;
        }
        if (menu) {
            menu.classList.remove('menu-container--user-menu-open');
        }
        $('#loginFormModal').modal('hide');
        $('#forgotten-pass-modal').fadeIn();
    });

    $('#forgotten-pass-modal .modal__closer, #forgotten-pass-modal .modal__overlay').on('click', function (e) {
        if(e.target == this) {
            $('#forgotten-pass-modal').fadeOut();
        }
    });

    $('.training-type-select .item').on('click', function(){
        $('.training-type-select .item').each(function(){
            $(this).removeClass('active');
        })
        $(this).addClass('active');
    });

    var optionDelay = 0;

    $('.quick-add__option').each(function() {
        var optionDelayString = optionDelay + 'ms';
        $(this).css('transition-delay', optionDelayString);
        optionDelay += 50;
    });

    $('#calendarActivityFormModal select[name="interval"], #calendarTrainingFormModal select[name="interval"], .activityModal select[name="interval"]').change(function () {
        var value = $(this).val();
        var period = $(this).parents('.row').find('input[name="period"]');
        var start = $(this).parents('form').find('input[name="start"]');
        var end = $(this).parents('form').find('input[name="end"]');
        var repeatNumber = $(this).parents('form').find('input[name="repeatNumber"]');
        var radios = $(this).parents('form').find('input[name="optionsRadios"]');
        if (value) {
            let dateVal = start.val();
            switch (value) {
                case 'P-W':
                    dateVal = moment(dateVal, 'DD.MM.YYYY').add(1, 'weeks').format('DD.MM.YYYY');
                    break;
                case 'P-M':
                    dateVal = moment(dateVal, 'DD.MM.YYYY').add(1, 'months').format('DD.MM.YYYY');
                    break;
                default:
                    break;
            }
            $(radios).closest('.repreatUntil').removeClass('hidden');
            $(radios).prop('disabled', false);
            period.val('1').prop("disabled", false);
            const checked = $(radios).filter(':checked');
            if (!checked[0] || $(checked[0]).val() !== '2') {
                $(radios[0]).prop('checked', true);
                end.closest('.endDate').addClass('hidden');
                end.prop("disabled", true);
                end.val(dateVal);
            }

            $('.repeatNumber').removeClass('hidden');
            repeatNumber.removeClass('hidden');
            $(this).parents('form').find('input[name="repeatNumber"]').prop('disabled', false);

        } else {
            $(radios).closest('.repreatUntil').addClass('hidden');
            $(radios).prop('disabled', true);
            $(radios).prop('checked', false);
            end.closest('.endDate').addClass('hidden');
            repeatNumber.closest('.repeatNumber').addClass('hidden');
            end.prop("disabled", true);
            period.val('').prop("disabled", true);
        }
    });

    $('input[name="optionsRadios"]').change(function () {
        var end = $(this).parents('form').find('.endDate');
        var repeatNumber = $(this).parents('form').find('.repeatNumber');
        if ($(this).val() === '1') {
            end.removeClass('hidden');
            repeatNumber.addClass('hidden');

            $(this).parents('form').find('input[name="end"]').prop('disabled', false);
            $(this).parents('form').find('input[name="repeatNumber"]').prop('disabled', true);
        } else {
            end.addClass('hidden');
            repeatNumber.removeClass('hidden');
            $(this).parents('form').find('input[name="end"]').prop('disabled', true);
            $(this).parents('form').find('input[name="repeatNumber"]').prop('disabled', false);
        }
    });

    $('.datetimepicker').datetimepicker({
        showClose: true,
        format:'DD.MM.YYYY'
    });

    $('.timepicker').datetimepicker({
        showClose: true,
        format:'HH:mm:00'
    });
})
    .on('click', 'a.js-more-ratings', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var url = $(this).attr('href');
        var lastRatingId = $('[data-rating-id]').last().attr('data-rating-id');
        loadingShow();

        // Append data
        $.ajax({
            url: url,
            data: {
                'lastRatingId': lastRatingId
            },
            success: function(data) {
                snippets(data);
            },
            complete: function(data) {
                loadingHide();
            }
        });

    })
    .on('click', 'a.ajax', function (e) {
        e.preventDefault();
        var url = $(this).attr('href');
        var modal = $(this).attr('data-modal');

        loadingShow();
        $.get(url).then(function () {
            loadingHide();
            if (modal) $('#' + modal).modal('show');
        });
    })
    .on('click', '.quick-add__button', function () {
        $('.quick-add').toggleClass('quick-add--opened');
    })
    .on('click', '.quick-add__options .quick-add__link', function (e) {
        var node = $(this);
        $('.quick-add').removeClass('quick-add--opened');

        if (node.data('type') !== 'activity' && node.data('type') !== 'training')
            return;

        e.preventDefault();

        if (node.data('type') === 'activity') {
            $('#activityCompleteModal h4').text(node.data('title'));
            $('input[type="hidden"][name="calendarEventId"]').val(node.data('calendar-event-id'));
            $('#activityCompleteModal').attr('data-id', node.data('calendar-event-id')).modal('show');
        } else {
            $('#trainingCompleteModal input[name="calendarEventId"]').val(node.data('calendar-event-id'));
            $('#trainingCompleteModal').attr('data-id', node.data('calendar-event-id')).modal('show');
        }
    })
    .on('click', '#activityCompleteModal button[data-button="go-one"], #activityCompleteModal a[data-button="go-one"]', function () {
        var id = $('#activityCompleteModal').attr('data-id');
        var link = '?do=activityDeleteOne&calendarEvent=' + id;

        if($(this).hasClass('js-modal-confirm')) { //modal confirm
            $(this).attr('data-href', link);
        } else { //direct delete
            window.location.href = link;
        }
    })
    .on('click', '#activityCompleteModal button[data-button="go-all"], #activityCompleteModal a[data-button="go-all"]', function () {
        var id = $('#activityCompleteModal').attr('data-id');
        var link = '?do=activityDeleteAll&calendarEvent=' + id;

        if($(this).hasClass('js-modal-confirm')) { //modal confirm
            $(this).attr('data-href', link);
        } else { //direct delete
            window.location.href = link;
        }
    })
    .on('change', '#calendarTrainingFormTrainingCategorySelect, #calendarTrainingFormTrainingTrainerSelect', function () {
        var category = $('#calendarTrainingFormTrainingCategorySelect').val();
        var trainer = $('#calendarTrainingFormTrainingTrainerSelect').val();

        loadingShow();

        $.get('?do=calendarTrainingFormTrainingSelect', {
            category: category,
            trainer: trainer
        }, function () {
            setTimeout(function () {
                $('.tagsInput').fastselect();
                loadingHide();
            }, 1);
        });
    })
    .on('change', '#calendarTrainingFormTrainingCategorySelect', function () {
        var value = $(this).val();

        if (value == '1') {
            $('#calendarTrainingFormTrainingTrainerSelectContainer').hide();
        } else {
            $('#calendarTrainingFormTrainingTrainerSelectContainer').show();
        }
    })
    .on('click', '#calendarActivityFormModal .switcher .btn', function (e) {
        e.preventDefault();
        var index = $(this).index();
        $(this).parents('.switcher').find('.btn').removeClass('active');
        $(this).addClass('active');
        $(this).parents('.modal-body').find('[data-switch]').hide();
        $(this).parents('.modal-body').find('[data-switch="' + index + '"]').show();
    });

$('.modal').on('shown.bs.modal', function () {
    //adjustImage();
    //adjustBox();
    //adjustImage2();
    //adjustBox2();
    $('.adjust-element-grid-2').responsiveEqualHeightGrid();
    setTimeout(function(){
        $(".scroll-box").niceScroll({
            cursorborder: "none",
            background:"transparent",
            cursorcolor: "transparent",
            horizrailenabled: false
        });
    }, 1500)
});

$('.modal').on('hide.bs.modal', function () {
    var id = $(this).attr('id');

    $('#' + id).find('iframe').each(function () {
        var url = $(this).attr('src');
        $(this).attr('src', '');
        $(this).attr('src', url);
    });
});

$( window ).load(function() {
    setTimeout(function () {
        //adjustImage();
        //adjustBox();
        //adjustImage2();
        //adjustBox2();
    }, 100);
});

function loadingShow() {
    $('.modal-loading').show();
    $('.modal-loading').animate({opacity:1},300);
}

function loadingHide() {
    $('.modal-loading').hide();
}


$(document).on('click', '.JSRegistrationTab', function() {
    let content = $(this).data('show-content');

    $('.JSRegistrationTab').removeClass('active');
    $(this).addClass('active');

    $('.JSRegistrationChanger').hide();
    $(content).show();

    return false;
});